import { render } from "./RedBtn.vue?vue&type=template&id=fb185482"
import script from "./RedBtn.vue?vue&type=script&lang=js"
export * from "./RedBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__